<script setup lang="ts">
import { computed } from 'vue'

interface DoorOpenFieldsData {
  voltage_field: string
}

interface Props {
  modelValue: DoorOpenFieldsData
}

interface Emits {
  (e: 'update:modelValue', value: DoorOpenFieldsData): void
}

const props = defineProps<Props>()
const emit = defineEmits<Emits>()

const formData = computed({
  get: () => props.modelValue,
  set: (value) => emit('update:modelValue', value),
})
</script>

<template>
  <div class="space-y-4">
    <div class="grid grid-cols-2 gap-4">
      <div>
        <label for="voltage_field" class="block text-sm font-medium"> Canal de tensão </label>
        <input
          v-model="formData.voltage_field"
          type="text"
          id="voltage_field"
          class="mt-1 block w-full border border-bodydark2 px-3 py-2 shadow-sm focus:border-indigo-500 focus:ring-indigo-500 sm:text-sm" />
      </div>
    </div>
  </div>
</template>
